import styled from 'styled-components';

export const HeaderRelated = styled.div`
  padding: 20px 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-gap: 10px;
  padding: 20px;

  a{
    text-decoration: none;
  }

  svg{
    margin-right: 10px;
  }

  @media (min-width: 30.5em) {
    grid-template-columns: repeat(auto-fill, minmax(336px, 1fr));
  }
`; 

export const ProgressContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100vh;
  background-color: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgressContent = styled.div`
  width: 100%;
  background-color: var(--white);
  max-width: 500px;
  padding: 20px;
  border-radius: 7px;
  overflow: auto;
  max-height: 400px;
  
  span{
    font-weight: bold;
    font-size: 0.6em;
    display: inline-block;
    padding: 2px;
    background-color: rgba(255, 165, 2,.1);
  }
`;

export const Header = styled.div`
  padding: 10px 5px;
  background-color: #eee;
  border: 1px solid #ededed;
  margin-bottom: 10px;
  margin-top: 10px;
`;